// extracted by mini-css-extract-plugin
module.exports = {"modalHeader":"modal_modalHeader__3f3kD","modalFooter":"modal_modalFooter__2VUFJ","cancelBtn":"modal_cancelBtn__3UdiQ","okBtn":"modal_okBtn__25MVy"};